export const forceFileDownload = (downloadUrl, fileName = null) => {
  const link = document.createElement("a");
  link.href = downloadUrl;
  fileName
    ? document.body.appendChild(link, fileName)
    : document.body.appendChild(link);
  link.click();
};
